import { type FC } from "react";

import { Badge } from "./badge";

// An amber count that does something of its own (e.g. shows what it counts);
// nothing at 0.
export const CountButton: FC<{
  count: number;
  label: string;
  onClick(): void;
}> = ({ count, label, onClick }) =>
  count > 0 && (
    <button
      type="button"
      aria-label={label}
      onClick={onClick}
      className="shrink-0"
    >
      <Badge pill color="amber">
        {count}
      </Badge>
    </button>
  );
